import { FlowchartConfig } from './infrastructure/base/flowchart.config';
import { NodePickerEvent } from './infrastructure/operations/node-picker-toolbar/node-picker-toolbar-items.config';

export function getDroppedElementPosition(
  paper: joint.dia.Paper,
  event: MouseEvent,
  elementType: NodePickerEvent,
): { x: number; y: number } {
  const localPoint = paper.clientToLocalPoint({ x: event.clientX, y: event.clientY });
  const gridSize = FlowchartConfig.paper.gridSize;

  const elementWidthMap: Record<NodePickerEvent, number> = {
    [NodePickerEvent.ADD_ACTION]: FlowchartConfig.nodeSize.default.width,
    [NodePickerEvent.ADD_DECISION]: FlowchartConfig.nodeSize.default.width,
    [NodePickerEvent.ADD_SEL_BEHAVIOR]: FlowchartConfig.selectionBehaviorNode.size.width,
    [NodePickerEvent.ADD_CONTAINER]: FlowchartConfig.containerNode.size.width,
    [NodePickerEvent.ADD_TEXT_BLOCK]: FlowchartConfig.textBlockNode.size.width,
    [NodePickerEvent.ADD_SUBFLOW]: FlowchartConfig.containerNode.size.width,
  };
  const elementWidth = elementWidthMap[elementType] ?? FlowchartConfig.nodeSize.default.width;
  const snappedX = Math.round((localPoint.x - elementWidth / 2) / gridSize) * gridSize;
  const snappedY = Math.round(localPoint.y / gridSize) * gridSize;

  return { x: snappedX, y: snappedY };
}
